import {
  ToggleButton as MuiToggleButton,
  ToggleButtonProps as MuiToggleButtonProps,
} from '@mui/material';

export type ToggleButtonProps = MuiToggleButtonProps;
export const ToggleButton = MuiToggleButton;
